import React from 'react';
import { useData } from '../context/DataContext';

const SHEET_ID     = '1g3a2JZcu4eZViII6c-8FquCyQGvFrB02z0ul2MhBix0';
const DOWNLOAD_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/export?format=xlsx`;

export default function Reportes() {
  const { clientes } = useData();

  const total         = clientes.length;
  const concretados   = clientes.filter(c => c.estado === 'Concretado').length;
  const noConcretados = clientes.filter(c => c.estado === 'No concretado').length;
  const prospectos    = clientes.filter(c => c.estado === 'Prospecto calificado').length;

  const pct = (n) => total > 0 ? Math.round((n / total) * 100) : 0;

  const stats = [
    { label:'Total prospectos', value:total,         color:'#185fa5', icon:'👥' },
    { label:'Concretados',      value:concretados,   color:'#16a34a', icon:'✅' },
    { label:'No concretados',   value:noConcretados, color:'#dc2626', icon:'❌' },
    { label:'En seguimiento',   value:prospectos,    color:'#d97706', icon:'⏳' },
  ];

  const barras = [
    { label:'Concretados',    value:concretados,   color:'#16a34a' },
    { label:'En seguimiento', value:prospectos,    color:'#d97706' },
    { label:'No concretados', value:noConcretados, color:'#dc2626' },
  ];

  return (
    <div style={{ padding:'24px 24px 80px', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <div style={{ marginBottom:24 }}>
        <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:'#0f172a' }}>Reportes</h1>
        <p style={{ margin:'4px 0 0', color:'#94a3b8', fontSize:13 }}>Estadísticas generales — Lady Fons</p>
      </div>

      {/* Stat cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(170px,1fr))', gap:14, marginBottom:24 }}>
        {stats.map(s => (
          <div key={s.label} style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
            <div style={{ fontSize:26, marginBottom:8 }}>{s.icon}</div>
            <p style={{ margin:0, fontSize:30, fontWeight:800, color:s.color }}>{s.value}</p>
            <p style={{ margin:'4px 0 0', fontSize:12, color:'#94a3b8', fontWeight:600 }}>{s.label}</p>
          </div>
        ))}
      </div>

      {/* Barras */}
      <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)', marginBottom:16 }}>
        <h3 style={{ margin:'0 0 20px', fontSize:15, fontWeight:800, color:'#0f172a' }}>Prospectos por estado</h3>
        {barras.map(b => (
          <div key={b.label} style={{ marginBottom:16 }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
              <span style={{ fontSize:13, fontWeight:600, color:'#475569' }}>{b.label}</span>
              <span style={{ fontSize:13, fontWeight:700, color:b.color }}>{b.value}</span>
            </div>
            <div style={{ background:'#f1f5f9', borderRadius:6, height:10, overflow:'hidden' }}>
              <div style={{ width: pct(b.value) + '%', background:b.color, height:'100%', borderRadius:6, transition:'width 0.6s ease' }} />
            </div>
          </div>
        ))}
      </div>

      {/* Descargar base de datos */}
      <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)', marginBottom:16 }}>
        <h3 style={{ margin:'0 0 6px', fontSize:15, fontWeight:800, color:'#0f172a' }}>Descargar datos</h3>
        <p style={{ margin:'0 0 16px', fontSize:13, color:'#94a3b8' }}>Descarga la base de datos completa directamente desde Google Sheets en formato Excel.</p>
        <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer"
          style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'11px 22px', background:'#16a34a', color:'#fff', borderRadius:8, textDecoration:'none', fontSize:13, fontWeight:700 }}>
          ↓ Descargar base de datos (.xlsx)
        </a>
      </div>

      {/* Tabla últimos registros */}
      <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
        <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:800, color:'#0f172a' }}>Últimos registros ({Math.min(clientes.length,10)} de {total})</h3>
        {clientes.length === 0
          ? <p style={{ textAlign:'center', color:'#94a3b8', fontSize:13, padding:'24px 0' }}>Sin datos aún — actualiza desde la sección Clientes</p>
          : clientes.slice(0,10).map((c,i) => (
            <div key={c.rowIndex} style={{ display:'flex', alignItems:'center', gap:14, padding:'10px 0', borderBottom: i < Math.min(clientes.length,10)-1 ? '1px solid #f1f5f9' : '' }}>
              <span style={{ fontSize:12, color:'#94a3b8', width:20, textAlign:'right', flexShrink:0 }}>{i+1}</span>
              <div style={{ width:36, height:36, borderRadius:18, background:'#185fa5', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800, fontSize:15, flexShrink:0 }}>
                {c.nombre.charAt(0).toUpperCase()}
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <p style={{ margin:0, fontSize:13, fontWeight:700, color:'#0f172a', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{c.nombre}</p>
                <p style={{ margin:'2px 0 0', fontSize:11, color:'#94a3b8' }}>{c.telefono}{c.modelo ? ' · '+c.modelo : ''}</p>
              </div>
              <span style={{ fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20, flexShrink:0,
                background: c.estado==='Concretado' ? '#dcfce7' : c.estado==='No concretado' ? '#fee2e2' : '#dbeafe',
                color:      c.estado==='Concretado' ? '#16a34a' : c.estado==='No concretado' ? '#dc2626' : '#1d4ed8' }}>
                {c.estado}
              </span>
            </div>
          ))
        }
      </div>
    </div>
  );
}
